<template>
  <b-row>
    <b-col v-if="can('read/bukti-bayar')" cols="12">
      <b-card title="Monitoring Pembayaran SPPD">
        <b-row class="pt-1 mb-2">
          <b-col lg="4" md="4" xs="12" class="mb-1">
            Periode
            <DatePicker
              v-model="dateRange"
              range
              format="DD-MM-YYYY"
              placeholder="Select Date Range"
              :unlink-panels="true"
              style="width: 100%;"
              @change="handleSearch"
            />
          </b-col>
          <b-col lg="4" md="4" xs="12" class="mb-1" v-if="showSubdir">
            Sub Direktorat
            <v-select
              id="subdir"
              v-model="selectedSubdir"
              label="text"
              placeholder="Cari Sub Direktorat"
              :options="selectedSubdirOptions"
              :disabled="disableSubdir"
              class="form-select w-100"
              v-on:change="handleSearch"
            />
          </b-col>
          <b-col lg="4" md="4" xs="12" class="mb-1" v-if="showRegional">
            Regional
            {{ userLoggedIn.company }}
          </b-col>
          <b-col lg="4" md="4" xs="12" class="mb-1" v-if="can('lokas/bukti-bayar')">
            Regional
            <v-select
              id="regional"
              v-model="selectedRegional"
              label="text"
              placeholder="Cari Regional"
              :options="selectedRegionalOptions"
              :disabled="disableRegional"
              class="form-select w-100"
              v-on:change="handleSearch"
            />
          </b-col>
          <b-col md="9">
            <b-button-group
              class="d-none d-lg-inline-flex filter-status-container"
            >
              <b-button
                v-for="opt in filterOptions"
                :key="opt.text"
                :variant="filter === opt.value ? 'primary' : 'outline-primary'"
                @click="filter = opt.value"
              >
                {{ opt.text }}
              </b-button>
              <!-- <b-button
                :variant="filter === 0 ? 'primary' : 'outline-primary'"
                @click="filter = 0"
              >
                Approval PA
              </b-button>
              <b-button
                :variant="filter === 1 ? 'primary' : 'outline-primary'"
                @click="filter = 1"
              >
                Menunggu Dibayarkan
              </b-button>
              <b-button
                :variant="filter === 2 ? 'primary' : 'outline-primary'"
                @click="filter = 2"
              >
                Dibayarkan Lokas
              </b-button>
              <b-button
                :variant="filter === 3 ? 'primary' : 'outline-primary'"
                @click="filter = 3"
              >
                Dibayarkan Pospay
              </b-button> -->
            </b-button-group>
            <div class="d-block d-lg-none mb-1">
              <b-form-select
                v-model="filter"
                :options="filterOptions"
              ></b-form-select>
            </div>
          </b-col>

          <b-col md="3" xs="12">
            <b-input-group size="8">
              <b-form-input
                v-model="search"
                type="search"
                :placeholder="'Cari disini...'"
              />
              <b-input-group-append>
                <b-button
                  class="btn-sm"
                  :disabled="!search"
                  @click="search = ''"
                >
                  Hapus
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <!-- {{ can('lokas/bukti-bayar') ? "lokas" : userLoggedIn.regional == '99' ? "pusat" : "regional" }} -->
        <b-table
          ref="tableFe"
          striped
          hover
          responsive
          show-empty
          class="position-relative"
          primary-key="email"
          :per-page="perPage"
          :current-page="currentPage"
          :items="getItems"
          :fields="can('lokas/bukti-bayar') ? fields_lokas : userLoggedIn.regional == '99' ? fields : fieldsRegional"
          :busy="busy"
        >
          <template #table-busy>
            <div class="text-center my-3">
              <!-- <b-spinner small type="grow" label="Loading..."></b-spinner> -->
              <div>Loading data, please wait...</div>
            </div>
          </template>

          <template #empty>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>
          <template #emptyfiltered>
            <div class="text-center my-2">Data tidak tersedia</div>
          </template>

          <template #cell(no)="data">
            {{ (currentPage - 1) * perPage + (data.index + 1) }}
          </template>

          <template #cell(name_subdirektorat)="data">
            {{ data.item.name_subdirektorat || "-" }}
          </template>
          <template #cell(name_regional)="data">
            {{ data.item.name_regional || "-" }}
          </template>

          <template #cell(name)="data">
            {{ data.item.nippos }} / {{ data.item.name }}
          </template>

          <template #cell(total_days)="data">
            {{ data.item.total_days }} hari
          </template>

          <template #cell(destination_office)="data">
            {{ data.item.destination_office || '-' }}
          </template>

          <template #cell(paid_at)="data">
            {{ data.item.paid_at || '-' | moment('DD-MM-YYYY') }}
          </template>

          <template #cell(status)="data">
            {{ data.item.status || '-' }}
          </template>

          <template #cell(created_at)="data">
            {{ data.item.created_at || '-' | moment('DD-MM-YYYY') }}
          </template>

          <!-- A virtual column -->
          <template #cell(Aksi)="data">
            <div style="min-width: 100px">
              <b-button
                v-if="
                  (data.item.status === 'Dibayarkan Lokas' ||
                    data.item.status === 'Dibayarkan Pospay') &&
                  can('print/bukti-bayar')
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-popover.hover.bottom="'Print'"
                variant="secondary"
                size="sm"
                class="btn-icon float-sm-left mr-1 mb-1"
                @click="print(data.item.sppd_id, data.item.sppd_number)"
              >
                <feather-icon icon="PrinterIcon" />
              </b-button>

              <b-button
                v-if="can('show/bukti-bayar') && can('show/bukti-bayar')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-popover.hover.bottom="'Detail'"
                variant="info"
                size="sm"
                class="btn-icon float-sm-left mr-1 mb-1"
                @click="gotoDetailPage(data.item.sppd_id)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>

              <b-button
                v-if="
                  data.item.status_paid == 0 &&
                  data.item.status_admin == 0 &&
                  can('approval_admin/bukti-bayar') &&
                  (role_name === 'Admin Nasional' || role_name === 'Admin Sppd')
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-popover.hover.bottom="'Approve Admin'"
                variant="success"
                size="sm"
                class="btn-icon float-sm-left mr-1 mb-1"
                @click="confirmApprove(data.item.sppd_id, 'admin')"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>

              <b-button
                v-if="
                  data.item.status_paid == 0 &&
                  data.item.status_admin == 1 &&
                  can('approval_pa/bukti-bayar') &&
                  (role_name === 'Approval Ruta/PA' || role_name === 'Admin PA Regional' || role_name === 'Approval PA Regional')
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-popover.hover.bottom="'Approve PA'"
                variant="success"
                size="sm"
                class="btn-icon float-sm-left mr-1 mb-1"
                @click="confirmApprove(data.item.sppd_id, 'pa')"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>

              <b-button
                v-if="
                  (data.item.status === 'Menunggu Approval Admin' ||
                    data.item.status === 'Menunggu Approval PA' ||
                    data.item.status === 'Menunggu Dibayarkan') &&
                  can('edit/bukti-bayar')
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-popover.hover.bottom="'Ubah'"
                variant="warning"
                size="sm"
                class="btn-icon float-sm-left mr-1"
                @click="gotoEditPage(data.item.sppd_id)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <span v-if="totalRows == 1" style="margin: 1rem"></span>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
              @change="changePerPage()"
            />
          </b-form-group>

          <div>
            Menampilkan {{ from }} hingga {{ to }} dari {{ totalRows }} entri
          </div>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col v-else>
      <b-card>
        <div class="col-12 p-2 p-sm-3 mb-4 mt-3">
          <div class="w-100 text-center">
            <h2 class="mb-1">Tidak Memiliki Akses</h2>
            <p class="mb-2">Anda tidak memiliki akses pada halaman ini</p>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
  .width160px {
    width: 160px !important;
    background-color: 'red !important';
  }
  .vs__dropdown-toggle, .vs__selected {
    max-width: none !important;
  }
</style>

<script>
import {
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BButtonGroup,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BCardBody,
  BFormGroup,
  BFormSelect,
  BPagination,
  VBPopover,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import debounce from 'debounce'
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import moment from 'moment'

import { getUserData, getUserRole } from '@/auth/utils'
import { can } from '@/@core/libs/acl/utils';

export default {
  name: 'SppdList',
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BButton,
    BButtonGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardBody,
    BFormGroup,
    BFormSelect,
    BPagination,
    vSelect,
    DatePicker,
  },
  directives: {
    Ripple,
    'b-popover': VBPopover,
  },
  data() {
    const currentYear = new Date().getFullYear();
    // const startOfYear = new Date(currentYear, 0, 1); // 1 Januari
    // // const startOfYear = new Date();
    // const endOfYear = new Date(currentYear, 11, 31); // 31 Desember

    return {
      config: {
        api: '/payments',
        status: '/misc/status-paid',
        subdir: '/misc/sub-direktorat',
        regional: '/misc/regionals',
      },
      filterOptions: [
        { value: "", text: 'Semua' },
        { value: '00', text: 'Menunggu Approval Admin' },
        { value: '01', text: 'Menunggu Approval PA' },
        { value: 1, text: 'Menunggu Dibayarkan' },
        // { value: 2, text: 'Dibayarkan Lokas' },
        { value: 3, text: 'Dibayarkan Lokas/Pospay' },
      ],
      isTriger: 0,
      filter: null,
      search: '',
      // dateRange: [startOfYear, endOfYear],
      dateRange: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 10,
      from: 1,
      to: 10,
      sortBy: 'id',
      selectedSubdir: null,
      selectedSubdirOptions: [],
      selectedRegional: null,
      selectedRegionalOptions: [],
      userLoggedIn: getUserData(),
      // userLoggedIn: JSON.parse(localStorage.getItem('userData')),
      showSubdir: false,
      showRegional: false,
      disableSubdir: false,
      disableRegional: false,
      pageOptions: [1, 10, 25, 50, 100],
      fields: [
        'no',
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name_subdirektorat', label: 'Subdirektorat' },
        { key: 'name', label: 'NIPPOS / Nama', thStyle: 'min-width:200px' },
        { key: 'total_days', label: 'Lama Perjalanan' },
        { key: 'destination_office', label: 'Tujuan' },
        { key: 'paid_at', label: 'Tanggal Dibayarkan' },
        { key: 'project_type', label: 'Sumber Anggaran' },
        { key: 'status', label: 'Status' },
        { key: 'created_at', label: 'Tanggal Pengajuan' },
        { key: 'Aksi', label: 'Aksi', stickyColumn: true, class: 'sticky-column pr-1'},
      ],
      fieldsRegional: [
        'no',
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name_regional', label: 'Regional' },
        { key: 'name', label: 'NIPPOS / Nama', thStyle: 'min-width:200px' },
        { key: 'total_days', label: 'Lama Perjalanan' },
        { key: 'destination_office', label: 'Tujuan' },
        { key: 'paid_at', label: 'Tanggal Dibayarkan' },
        { key: 'project_type', label: 'Sumber Anggaran' },
        { key: 'status', label: 'Status' },
        { key: 'created_at', label: 'Tanggal Pengajuan' },
        { key: 'Aksi', label: 'Aksi', stickyColumn: true, class: 'sticky-column pr-1'},
      ],
      fields_lokas: [
        'no',
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'name_subdirektorat', label: 'Subdirektorat' },
        { key: 'name_regional', label: 'Regional' },
        { key: 'name', label: 'NIPPOS / Nama', thStyle: 'min-width:200px' },
        { key: 'total_days', label: 'Lama Perjalanan' },
        { key: 'destination_office', label: 'Tujuan' },
        { key: 'paid_at', label: 'Tanggal Dibayarkan' },
        { key: 'project_type', label: 'Sumber Anggaran' },
        { key: 'status', label: 'Status' },
        { key: 'created_at', label: 'Tanggal Pengajuan' },
        { key: 'Aksi', label: 'Aksi', stickyColumn: true, class: 'sticky-column pr-1'},
      ],
      items: [],
      // role_name: JSON.parse(localStorage.getItem('userData')).role_name,
      role_name: getUserRole(),
      busy: false,
    }
  },
  watch: {
    filter: function () {
      // console.log("filter changed: ", this.filter);
      this.isTriger = 1;
      this.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()
    },
    search: debounce(function () {
      // console.log("search changed: ", this.search);
      this.isTriger = 1;
      this.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()
    }, 300),
    selectedSubdir: function (newValue) {
      // console.log("selectedSubdir changed: ", this.selectedSubdir);
      this.isTriger = 1;
      this.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()

      if (newValue && newValue.value != '0') {
        this.disableSubdir = false;
        this.disableRegional = true;
      } else {
        this.disableSubdir = false;
        this.disableRegional = false;
      }
    },
    selectedRegional: function (newValue) {
      // console.log("selectedRegional changed: ", this.selectedRegional);
      this.isTriger = 1;
      this.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()

      if (newValue && newValue.value != '0') {
        this.disableSubdir = true;
        this.disableRegional = false;
      } else {
        this.disableSubdir = false;
        this.disableRegional = false;
      }
    },
  },
  mounted() {
    const _ = this
    _.getSubdirList();
    _.getRegionalList();

    if(_.userLoggedIn.regional == '99') {
      _.showSubdir = true;
      _.showRegional = false;
      // _.getRegionalList();
    } else {
      _.showSubdir = false;
      _.showRegional = true;
    }

    if (_.$route.params) {
      if (_.$route.params.event) {
        _.makeToast(
          _.$route.params.event,
          _.$route.params.title,
          _.$route.params.text,
        )
      }
    }
    // this.getStatusList()
  },
  methods: {
    getStatusList() {
      axios
        .get(this.config.status)
        .then(resp => {
          if (resp.data.data?.length) {
            this.filterOptions = [
              ...this.filterOptions,
              ...resp.data.data.map(({ id, name }) => ({
                value: id,
                text: name,
              })),
            ]
          }
        })
        .catch(() => {
          // console.log(err)
        })
    },
    getSubdirList() {
      axios.get(this.config.subdir).then(response => {
        // this.selectedSubdirOptions = response.data.data
        var header = [{
          text: "Pilihan Semua Sub Direktorat",
          value: "0"
        }];
        var options = response.data.data.map(item => ({
          // text: item.namabagian_child.length > 30 ? item.namabagian_child.substr(0, 29)+"..." : item.namabagian_child,
          text: item.namabagian_child,
          value: item.kodebagian_child
        }));
        // console.log(options);

        this.selectedSubdirOptions = [...header, ...options];
        // console.log(this.selectedSubdirOptions);
        
      })
      .catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    getRegionalList() {
      axios.get(this.config.regional).then(response => {
        // this.regionalLists = response.data.data.data
        // this.selectedRegionalOptions = response.data.data.data.map(item => ({
        //   text: item.nmwilayah.length > 40 ? item.nmwilayah.substr(0, 40)+"..." : item.nmwilayah,
        //   value: item.idwilayah
        // }));
        var header = [{
          text: "Pilihan Semua Regional",
          value: "0"
        }];
        var options = response.data.data.data.map(item => ({
          text: item.nmwilayah,
          value: item.idwilayah
        }));

        this.selectedRegionalOptions = [...header, ...options];
      })
      .catch(error => {
        console.error(error)

        var message = "";
        if(typeof error.response.data.message === 'object'){
          message = error.response.data.message.errors[0].msg
        } else {
          message = error.response.data.message
        }
        this.makeToast('danger', "Terjadi Kesalahan", message)
      });
    },
    gotoDetailPage(id) {
      const _ = this
      _.$router.push(`/bukti-bayar/${id}/detail`)
    },
    gotoEditPage(id) {
      const _ = this
      _.$router.push(`/bukti-bayar/${id}/edit`)
    },
    getItems(ctx, callback) {
      const _ = this
      _.busy = true;

        let endpoint = `${_.config.api}?isTriger=${_.isTriger}&per_page=${_.perPage}&page=${_.currentPage}`
        if (_.filter !== null && _.filter !== '') {
          if (_.filter[0] == 0) {
            endpoint += `&status=0&status_admin=${_.filter[1]}`
          } else {
            endpoint += `&status=${_.filter}`
          }
        }
        if (_.search) {
          endpoint += `&key=${_.search}`
        }

        if(_.selectedSubdir) {
          endpoint +=  `&subdir=${_.selectedSubdir.value}`
        }

        if(_.selectedRegional) {
          endpoint +=  `&regional=${_.selectedRegional.value}`
        }

        if(_.userLoggedIn.regional != '99') {
          endpoint +=  `&regional=${_.userLoggedIn.regional}`
        }

        if (_.dateRange.length > 0) {
          console.log(_.dateRange);

          const currentYear = new Date().getFullYear();
          const stDate = _.dateRange[0] ?? new Date(currentYear, 0, 1);
          const edDate = _.dateRange[1] ?? new Date(currentYear, 11, 31);
          
          var startDate = moment(stDate).format('YYYY-MM-DD');
          var endDate = moment(edDate).format('YYYY-MM-DD');
          // console.log(startDate, endDate);
          // endpoint += `&start_date=${_.dateRange[0]}&end_date=${_.dateRange[1]}`
          endpoint += `&start_date=${startDate}&end_date=${endDate}`
        }
        // console.log("endpoint : ", endpoint);
        axios
          .get(endpoint)
          .then(resp => {
            const consume = resp.data.data
            // console.log(consume);
            _.perPage = consume.per_page
            _.currentPage = consume.current_page
            _.totalRows = consume.total
            _.from = consume.from || 0
            _.to = consume.to || 0
            callback(consume.data || [])
          })
          .catch(error => {
            console.error(error)

            var message = "";
            if(typeof error.response.data.message === 'object'){
              message = error.response.data.message.errors[0].msg
            } else {
              message = error.response.data.message
            }
            this.makeToast('danger', "Internal Server Error", message)
          })
          .finally(() => {
            _.busy = false;
          });
      
      return null
    },
    changePerPage() {
      const _ = this
      _.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()
    },
    makeToast(variant = null, title = 'Title here...', text = 'Text here...') {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      })
    },
    confirmApprove(id, type) {
      this.$swal({
        title: 'Apakah Anda Yakin',
        text: 'untuk menyetujui Bukti Bayar SPPD tersebut?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        let url = ''
        let body = {}

        if (type === 'admin') {
          url = `${this.config.api}/${id}/approve-admin`
        }
        if (type === 'pa') {
          url = `${this.config.api}/${id}`
          body = { 
            status: 1, 
            nipppos: (this.userLoggedIn && this.userLoggedIn.nippos) || null 
          }
        }

        if (result.value) {
          axios
            .put(url, body)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Berhasil Disetujui',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
              this.$refs.tableFe.refresh()
              // this.$refs.tableFeRegional.refresh()
            })
            .catch(error => {
              var message = "";
              if(typeof error.response.data.message === 'object'){
                message = error.response.data.message.errors[0].msg
              } else {
                message = error.response.data.message
              }
              this.$swal({
                icon: 'Danger',
                title: 'Terjadi kesalahan!',
                text: message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
    handleSearch() {
      this.isTriger = 1;
      this.$refs.tableFe.refresh()
      // this.$refs.tableFeRegional.refresh()
    },
    print(id, sppdNumber) {
      axios
        .get(`${this.config.api}/${id}/print`, {
          responseType: 'blob',
        })
        .then(res => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: 'application/pdf' }),
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Bukti-Bayar-${sppdNumber}.pdf`)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
    },
  },
}
</script>

<style>
.b-popover {
  font-size: 10px;
}

@media screen and (max-width: 1440px) {
  .filter-status-container button {
    font-size: 12px;
  }
}
</style>
